<script>
import {copy as copyToClipboard} from '@core/Util/clipboard';
import resource from "@core/Util/resources";

export default {
    functional: true,
    render(createElement, context) {
        return createElement('button', {
            class: 'btn btn-xs btn-outline-secondary',
            on: {
                click: () => copyToClipboard(context.props.id)
            }
        }, [resource('JourneyBuilder_CopyId_Button')])
    }
}
</script>
